import { render, staticRenderFns } from "./uangjajan.vue?vue&type=template&id=7ac2fc42&"
import script from "./uangjajan.vue?vue&type=script&lang=js&"
export * from "./uangjajan.vue?vue&type=script&lang=js&"
import style0 from "./uangjajan.vue?vue&type=style&index=0&id=7ac2fc42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports